import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { EventViewModel } from '../../../../models-views/event.view.model';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { BehaviorSubject, Subject, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs';
import { OutsourcingFormResponseModel, OutsourcingRequestResponseModel } from '../../../../models/outsourcing.model';
import LoginModel from '../../../../models/user.model';
import { AppCommon } from '../../../../providers/app-common';
import { QuillCustomServices } from '../../../../providers/quill-config';

interface IModalData {
  eventId: any;
  data: any;
}

@Component({
  selector: 'app-cet-inquiry-modal',
  standalone: false,
  templateUrl: './cet-inquiry-modal.component.html',
  styleUrl: './cet-inquiry-modal.component.scss'
})
export class CetInquiryModalComponent {
  timezones:any = [];
  destroy$ = new BehaviorSubject<boolean>(false);
  private timezoneSearch$ = new Subject<string>();
  form: FormGroup;
  eventId: any;
  readonly nzModalData: IModalData = inject(NZ_MODAL_DATA);
  dataMsg:string = 'Creating inquery...';
  loading:boolean = false;
  loginModel = new BehaviorSubject<LoginModel>(new LoginModel());
  // outsourcingTypes = []; // Populate this later
  // formOptions = []; // Populate this later
  outsourcingRequestResponseModel = new BehaviorSubject<OutsourcingRequestResponseModel>(
      new OutsourcingRequestResponseModel());
  outsourcingFormsResponseModel = new BehaviorSubject<OutsourcingFormResponseModel>(new OutsourcingFormResponseModel());
  quillConfig:any


  // quillConfig = {
  //   toolbar: [
  //     ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
  //     ['blockquote', 'code-block'],
  //     [{ 'header': 1 }, { 'header': 2 }],               // custom button values
  //     [{ 'list': 'ordered'}, { 'list': 'bullet' }],
  //     [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
  //     [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
  //     [{ 'direction': 'rtl' }],                        // text direction
  //     [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  //     [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults
  //     [{ 'font': [] }],
  //     [{ 'align': [] }],
  //     ['clean'],                                        // remove formatting
  //     ['link', 'image', 'video']                        // link and image, video
  //   ]
  // };

  constructor(private vm: EventViewModel, private route: ActivatedRoute,
    private fb: FormBuilder, private modalRef: NzModalRef,
    private quilservice:QuillCustomServices) {
     
    this.loginModel.next(AppCommon.getloggedInObject());
    this.form = this.fb.group({
        request_title: ['', Validators.required],
        due_date: [null, Validators.required],
        time_zone: [null],
        outsourcing_event_request: [null, Validators.required], // select
        outsourcing_form: [null, Validators.required], // select
        general_instructions_for_vendors: ['']
      });

      if(this.nzModalData.data){
        this.updateForm();
      }

      this.vm.timezone.subscribe( (d:any) =>   this.timezones = d.results );
      this.quillConfig = this.quilservice.QuillConfigDefault;

      this.timezoneSearch$.pipe(
        debounceTime(400),
        distinctUntilChanged()
      ).subscribe(term => this.vm.getTimezoneList(term));

  }

  ngOnInit(): void {
    this.eventId = this.nzModalData?.eventId;
    this.vm.parentCetInquiryModalComponent = this;
   
    this.vm.subscribeToOutSourcingEventRequest(this.outsourcingRequestResponseModel);
    this.vm.subscribeToOutsourcingForm(this.outsourcingFormsResponseModel); 
    this.vm.getOutSourcingEventRequests('', 1, 100, this.eventId, 'inquiry-modal');
    this.vm.getTimezoneList()
  }

  updateForm(){
    let d = {
      request_title: this.nzModalData.data.request_title,
      due_date: this.nzModalData.data.due_date,
      time_zone: this.nzModalData.data.time_zone,
      outsourcing_event_request: this.nzModalData.data.outsourcing_event_request,
      outsourcing_form: this.nzModalData.data.outsourcing_form,
      general_instructions_for_vendors: this.nzModalData.data.general_instructions_for_vendors,
    }
   this.nzModalData.data?.outsourcing_event_request_details.outsourcing_type_details?.id &&
   this.vm.getOutSourcingForm(1, 100, this.nzModalData.data?.outsourcing_event_request_details.outsourcing_type_details?.id, 'cet-inquiry-modal'); 
   
   this.form.patchValue(d);
  }

  onTimezoneSearch(value: string): void {
    this.timezoneSearch$.next(value);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
    this.timezoneSearch$.complete();
  }
  

  handleModalCancel(): void {
    this.form.reset();
    this.modalRef.close();
  }

  getForms($event){
    this.form.get('outsourcing_form').reset();
    const item = this.outsourcingRequestResponseModel.value.results.find(el => {
      return el.id === $event;
    });
    this.vm.getOutSourcingForm(1, 100, item.outsourcing_type_details?.id, 'cet-inquiry-modal'); 
  }

  onSubmit(): void {
    if (this.form.valid) {
        var payload = this.form.value;
        payload.event = this.eventId;
        payload.status = 'DRAFT';
      if(this.nzModalData.data){
        payload.modified_by = this.loginModel.value.user.id;
        payload.id = this.nzModalData.data.id;
        this.dataMsg = 'Updating inquery...';
        this.loading = true;
        this.vm.updateQuotationRequest(payload);
      } else {
        this.loading = true;
        payload.created_by = this.loginModel.value.user.id;
        this.vm.createQuotationRequest(payload);
      }
    
      
    } else {
      console.warn('Form invalid');
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      this.form.updateValueAndValidity()
    }
  }

  QuotationRequestCreated(){
    this.form.reset();
    this.modalRef.close(true);
  }


}
